import { atom } from "jotai";

/**
 * EXPECTED DATA from GET /role-access/get-by-role-profile:
 * [
 *   {
 *     "menuId": 11,
 *     "menuCode": "COURSES",
 *     "menuName": "Courses",
 *     "canCreate": 0,
 *     "canRead": 1,
 *     "canUpdate": 0,
 *     "canDelete": 0
 *   }
 * ]
 */
export const roleAccessListAtom = atom([]);
export const userMainRoleAtom = atom(null);
